export default {
  namespaced: true,
  state: {
    modal: {
      isOpen: false,
      resolve: (bool) => bool, 
			reject: (bool) => bool, 
    }
  },
  getters: {
    isOpen:(state)=>state.modal.isOpen,
  },
  mutations: {
    commitModalOpen(state, data) {
      state.modal = data
    },
    commitResetModalState(state) {
			state.modal = {
				resolve: (bool) => bool,
				reject: (bool) => bool,
			}
		},
  },
  actions: {
    actionModalOpen({commit}, data) {
			return new Promise((resolve, reject) => {
				const option = {
					resolve,
					reject,
					...data,
				}
				commit('commitModalOpen', option)
			})
		},
		actionModalResolve({ commit, state }) {
			state.modal.resolve(true)
			commit('commitResetModalState')
    },
		actionModalReject({ commit, state }) {
			state.modal.reject(false) 
			commit('commitResetModalState')
		},
  }
}